<template>
  <div>
    <div v-if="loading" class="text-center p-5">Loading slide promotions...</div>

    <div v-else>
      <div v-if="slides.length === 0" class="text-center text-muted p-4 border rounded">
        No slide promotion available.
      </div>

      <table v-else class="table">
        <thead>
          <tr>
            <th>Image</th>
            <th>URL</th>
            <th class="text-right">Action</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="item in slides" :key="item.id">
            <td>
              <a v-if="item.urlImage" :href="item.UrlImage" target="_blank">
                <img
                  :src="item.urlImage"
                  alt="Slide"
                  style="width: 50px; height: 50px; object-fit: cover; border-radius: 4px;"
                />
              </a>
              <span v-else class="text-muted small">No image</span>
            </td>

            <td>
              <a :href="item.url" target="_blank">{{ item.Url | truncate(50) }}</a>
            </td>

          

            <td class="text-right">
              <img
                src="../../assets/img/edit-btn.png"
                width="30"
                class="mr-2"
                @click="editSlide(item)"
              />
              <img
                src="../../assets/img/delete-btn.png"
                width="30"
                @click="deleteSlide(item)"
              />
            </td>
          </tr>
        </tbody>
      </table>

      <!-- 🧩 Add/Edit Popup -->
      <div v-if="openSlidePromote" class="upload-popup-overlay" @click.self="closeSlidePromote">
        <div class="upload-popup-card">
          <button class="close-btn" @click="closeSlidePromote">×</button>
          <h4 class="popup-title text-left">
            {{ isEditing ? "Edit Slide Promotion" : "Upload Slide Promotion" }}
          </h4>

          <!-- URL -->
          <div class="text-left mt-4">
            <label>Url</label>
            <CInput v-model="urlSlide" type="text" placeholder="Enter URL..." />
          </div>

          <!-- Upload Zone -->
          <div
            class="upload-dropzone"
            @click="triggerFileInputSlidePromote"
            @dragover.prevent
            @drop.prevent="handleDrop"
          >
            <input
              type="file"
              ref="fileInputSlidePromote"
              @change="handleFilesSlidePromote"
              accept=".png,.jpg,.jpeg"
              style="display:none"
            />

            <!-- Preview existing or new -->
            <div v-if="previewUrlSlidePromote" class="image-preview">
              <img :src="previewUrlSlidePromote" alt="Preview" class="preview-img" />
            </div>

            <div v-else class="upload-content">
              <img src="../../assets/img/upload.png" alt="Upload Icon" class="upload-icon" />
              <p class="upload-text">Browse File</p>
              <p class="upload-subtitle">Choose a file or drag & drop it here</p>
              <p class="upload-format-text">PNG, JPG, or JPEG formats, up to 10 MB</p>
            </div>
          </div>

          <!-- File Preview -->
          <div v-if="uploadedFileSlidePromote" class="file-preview">
            <span class="file-name">
              <i class="fa fa-paperclip"></i> {{ uploadedFileSlidePromote.name }}
            </span>
            <button class="remove-file" @click="removeFileSlidePromote">×</button>
          </div>

          <!-- Submit -->
          <button
            class="upload-submit-btn"
            :disabled="isUploading"
            @click="submitSlidePromote"
          >
            {{ isUploading ? "Saving..." : isEditing ? "Update" : "Upload" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SlidePromotionList",
  data() {
    return {
      slides: [],
      loading: false,
      openSlidePromote: false,
      isEditing: false,
      selectedSlideId: null,

      urlSlide: "",
      uploadedFileSlidePromote: null,
      uploadedFileUrl: "",
      uploadedFileId: null,
      previewUrlSlidePromote: "",
      isUploading: false,
    };
  },
  filters: {
    truncate(value, limit) {
      if (!value) return "";
      return value.length > limit ? value.substring(0, limit) + "..." : value;
    },
  },
  methods: {
    async loadSlide() {
      this.loading = true;
      try {
        const res = await this.$API.get(this.$GetListSlidePromotion, { withCredentials: true });
        if (Array.isArray(res.data)) {
          this.slides = res.data;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    // 🟢 Add new
    openAddSlide() {
      this.isEditing = false;
      this.selectedSlideId = null;
      this.urlSlide = "";
      this.previewUrlSlidePromote = "";
      this.uploadedFileSlidePromote = null;
      this.openSlidePromote = true;
    },

    // ✏️ Edit existing
    editSlide(item) {
      this.isEditing = true;
      this.selectedSlideId = item.id;
      this.urlSlide = item.Url;
      this.previewUrlSlidePromote = item.urlImage;
      this.uploadedFileUrl = item.urlImage;
      this.uploadedFileId = item.fileAwsId;
      this.openSlidePromote = true;
    },

    // 🔁 File handling
    triggerFileInputSlidePromote() {
      this.$refs.fileInputSlidePromote.click();
    },
    handleFilesSlidePromote(e) {
      const file = e.target.files[0];
      if (!file) return;
      this.uploadedFileSlidePromote = file;
      this.previewUrlSlidePromote = URL.createObjectURL(file);
    },
    removeFileSlidePromote() {
      this.uploadedFileSlidePromote = null;
      this.previewUrlSlidePromote = "";
    },

    // 🚀 Upload or update
    async submitSlidePromote() {
      this.isUploading = true;
      try {
        let fileUrl = this.uploadedFileUrl;
        let fileId = this.uploadedFileId;

        // 🖼️ Upload new file if chosen
        if (this.uploadedFileSlidePromote) {
          const formData = new FormData();
          formData.append("file", this.uploadedFileSlidePromote);
          const res = await this.$API.post(this.$UploadFileSlide, formData, {
            withCredentials: true,
            timeout: 600000,
          });

          const uploaded = Array.isArray(res.data) ? res.data[0] : res.data;
          if (uploaded.success) {
            fileId = uploaded.fileId;
            let cleanUrl = uploaded.fileUrl;
            const prefix = "URL: ";
            if (cleanUrl && cleanUrl.startsWith(prefix)) cleanUrl = cleanUrl.substring(prefix.length);
            fileUrl = cleanUrl;
          } else {
            alert("❌ Upload failed: " + (uploaded.error || "Unknown error"));
            return;
          }
        }

        // 💾 Save to API
        const payload = {
          id: this.selectedSlideId || 0,
          url: this.urlSlide,
          urlToImage: fileUrl,
          fileAwsId: fileId,
          status: true,
        };

        const res = await this.$API.post(this.$InsertSlidePromotion, payload, {
          withCredentials: true,
          timeout: 600000,
        });

        alert(`✅ Slide ${this.isEditing ? "updated" : "added"} successfully!`);
        this.closeSlidePromote();
        this.loadSlide();
      } catch (err) {
        console.error(err);
        alert("⚠️ Error uploading or saving slide.");
      } finally {
        this.isUploading = false;
      }
    },

    // 🗑️ Delete (soft delete)
    async deleteSlide(item) {
      if (!confirm("Are you sure to delete this slide?")) return;

      try {
        const payload = {
          id: item.id,
          Url: item.Url,
          urlToImage: item.urlImage,
          fileAwsId: item.fileAwsId,
          status: false,
        };

        await this.$API.post(this.$InsertSlidePromotion, payload, { withCredentials: true });
        alert("🗑️ Slide deleted successfully!");
        this.loadSlide();
      } catch (err) {
        console.error(err);
        alert("⚠️ Failed to delete slide.");
      }
    },

    closeSlidePromote() {
      this.openSlidePromote = false;
    },
  },
  mounted() {
    this.loadSlide();
  },
};
</script>